export default __webpack_public_path__ + "bb78dbdc65643be35e9ca4c674d50b18.svg";